module.exports = {
	"disclaimer": "To obtain a shipping quote, proceed to checkout and complete your purchase.  You will not be charged at this time.  Within 48 hours, you will receive a shipping quote via email for your approval.  If you do not approve the quote, you will not be charged and your order will be cancelled.",
	"legal": "Customs duties and taxes may apply to international purchases. ",
	"linkCTA": "Learn More ",
	"link": "https://support.1stdibs.com/s/article/Customs-Duties-Taxes-for-International-Shipments",
	"preDisclaimer": {
		"canRequestQuote": {
			"copy": "Need different shipping arrangements?  ",
			"linkCTA": "Request a shipping quote >"
		},
		"standard": "Shipping somewhere else? ",
		"trade": "Shipping somewhere else or need expedited delivery? ",
		"none": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsFooter.json
// module id = 1580
// module chunks = 4 14